import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SubCategoryList from './subcatList';
import Modal from '../../common/Modal';
import ArrowIcon from '../../icons/Arrow';
import useDebounce from '../../hooks/useDebounce';

const ListHeader = styled.div`
  background: ${({ theme }) => theme.colors.Primary};
  height: 56px;
`;

const Back = styled(ArrowIcon)`
  padding: 20px 15px;
  flex: 0 0 45px;
`;

const SearchBar = styled.input`
  width: 50%;
  color: #fff;
  border: none;
  padding-left: 10px;
  background: transparent;
  outline: none;
  ::placeholder {
    color: #fff;
    opacity: 0.5;
  }
`;

const ListBody = styled.ul`
  margin-top: 56px;
`;

const ListElement = styled.a`
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
  color: ${({ theme }) => theme.colors.TextAlpha};
`;

const Div = styled.div`
  max-height: 100%;
  overflow: auto;
  background: white;
  div {
    width: 100%;
  }
`;

const SubcatSelection = ({
  isMobile,
  openSubcat,
  categories,
  activeIndex,
  handleBack,
  parentArray,
  setParentArray,
  immediateTransion = true
}) => {
  const [openSearch, setOpenSearch] = useState(false);
  const [searchCat, setSearchCat] = useState([]);
  const [keyword, setKeyword] = useState('');
  const debouncedSearch = useDebounce(keyword, 1000);

  const handleSearch = keyword => {
    const result = parentArray
      .filter(each => each.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1)
      .slice(0, 8);
    return result;
  };

  const handleKeyup = e => {
    const { value } = e.target;
    setKeyword(value);
  };

  useEffect(() => {
    const res = categories
      .map(each => {
        if (each.subtype) {
          return each.subdata.map(each => {
            if (each.content && each.content.length > 0) {
              if (each.content[0].subtype) {
                return each.content.map(each => each.content);
              }
              return each.content;
            }
          });
        }
        return each.subcat;
      })
      .flat(Infinity);
    setParentArray(res);
  }, []);

  useEffect(() => {
    if (debouncedSearch) {
      if (debouncedSearch && debouncedSearch.length > 1) {
        setSearchCat(handleSearch(debouncedSearch));
      }
    } else {
      setSearchCat([]);
    }
  }, [debouncedSearch]);

  return (
    <>
      {openSubcat &&
        (immediateTransion ? (
          <Modal show={true} full={true} size="sm" withHeader={false} slideFrom="right">
            <SubCategoryList
              isMobile={isMobile}
              categories={categories}
              activeIndex={activeIndex}
              setOpenSearch={setOpenSearch}
              handleBack={handleBack}
            />
          </Modal>
        ) : (
          <Div className="pF l0 t0 w100 h100 dF">
            <SubCategoryList
              isMobile={isMobile}
              categories={categories}
              activeIndex={activeIndex}
              setOpenSearch={setOpenSearch}
              handleBack={handleBack}
            />
          </Div>
        ))}
      {openSearch && (
        <Modal show={true} full={true} size="sm" withHeader={false}>
          <ListHeader className="dFA w100 pF zi1">
            <Back
              onClick={() => {
                setSearchCat([]);
                setOpenSearch(false);
              }}
            />
            <SearchBar
              placeholder="What will you sell today?"
              type="text"
              autoFocus={true}
              maxLength={30}
              onKeyUp={handleKeyup}
              autocomplete="off"
            />
          </ListHeader>
          {searchCat && searchCat.length > 0 && (
            <ListBody>
              {searchCat.map((each, index) => (
                <ListElement className="dB" href={each.href} key={index}>
                  {each.name}
                </ListElement>
              ))}
            </ListBody>
          )}
        </Modal>
      )}
    </>
  );
};

SubcatSelection.propTypes = {
  isMobile: PropTypes.bool,
  openSubcat: PropTypes.bool,
  immediateTransion: PropTypes.bool,
  activeIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  categories: PropTypes.array,
  parentArray: PropTypes.array,
  setParentArray: PropTypes.func,
  handleBack: PropTypes.func
};

export default SubcatSelection;
